import { SolutionV3 } from '@/src/types/fareFamilyInfo'
import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface FareFamilyInfoResponseV3 {
    responseCode: number
    error: any | null
    success: boolean
    data: {
        solutions: SolutionV3[] // V3 uses SolutionV3 with index field
        totalDateChangeFee: Record<string, number>
        isAmendable: Record<string, boolean>
        isRefundable: Record<string, boolean>
        refundableAmountOnCancellation: Record<string, number>
    }
    isSuccess: boolean
}

export const fareFamilyApiV3 = createApi({
    reducerPath: 'fareFamilyApiV3',
    baseQuery: fetchBaseQuery({
        prepareHeaders: (headers, api) => {
            return setCommonHeaders(headers)
        }
    }),

    tagTypes: ['FareFamilyV3'],
    // Keep unused cached data for 10 minutes (600 seconds)
    keepUnusedDataFor: 600,

    endpoints: builder => ({
        getFareFamilyInfoV3: builder.query<FareFamilyInfoResponseV3, { itineraryId: string }>({
            query: ({ itineraryId }) => `/itin/${itineraryId}/v3/fare-family-info`,
            transformResponse: (response: FareFamilyInfoResponseV3) => {
                // Sort solutions by index to maintain consistent array position
                // This ensures solutions[0] has index: 0, solutions[1] has index: 1, etc.
                if (response?.data?.solutions && Array.isArray(response.data.solutions)) {
                    response.data.solutions.sort((a, b) => a.index - b.index)
                }
                return response
            },
            transformErrorResponse: (response, meta, arg) => {
                const { status, data } = response
                return {
                    status: status,
                    message: `Fare family info request failed with status ${status}`,
                    itineraryId: arg.itineraryId,
                    data: data || {}
                }
            },
            providesTags: (result, error, { itineraryId }) => [
                { type: 'FareFamilyV3', id: `${itineraryId}-fareFamilyInfoV3` }
            ]
        })
    })
})

// Export hooks for usage in components
export const { useGetFareFamilyInfoV3Query } = fareFamilyApiV3

// Export the API slice for store configuration
export default fareFamilyApiV3
